import {
  type IPSubnetInputValueOrDraft,
  getIPSubnetZodValidationError,
  isIpSubnetInputValidValue,
} from '@ipfabric/ui-components/IPSubnetInput/IPSubnetInput.types';
import { z } from 'zod';

export const ipCidrListSchemaZ = z
  .custom<IPSubnetInputValueOrDraft>()
  .refine(isIpSubnetInputValidValue, getIPSubnetZodValidationError);
